// The value written to the record stays Hebrew whatever the interface
// language is - it is data. Only the label the user reads is translated.
export const MARITAL_STATUSES = [
  { value: 'רווק/ה', key: 'marital_single' },
  { value: 'נשוי/אה', key: 'marital_married' },
  { value: 'גרוש/ה', key: 'marital_divorced' },
  { value: 'אלמן/ה', key: 'marital_widowed' },
  { value: 'פרוד/ה', key: 'marital_separated' },
  { value: 'ידוע/ה בציבור', key: 'marital_partner' },
]

const FINAL_LETTERS: { [letter: string]: string } = { 'ך': 'כ', 'ם': 'מ', 'ן': 'נ', 'ף': 'פ', 'ץ': 'צ' }

// אלמן becomes אלמנה in the feminine, where the final nun is written in its
// ordinary form, so the two only compare equal once the ending is folded.
const root = (value: string) =>
  value.split('/')[0].trim().replace(/[ךםןףץ]/g, letter => FINAL_LETTERS[letter])

// Records hold spellings this list never produced - 'נשוי/ה' on rows written
// before it existed, 'נשוי' on rows that came in from a CSV. A <select> whose
// value matches no option renders the first one instead, so a married contact
// read as רווק/ה. Map such a value onto the option it means; anything still
// unrecognised is handed back untouched for the screen to show as it stands.
export const normalizeMaritalStatus = (value: any): string => {
  const raw = typeof value === 'string' ? value.trim() : ''
  if (!raw) { return '' }

  const exact = MARITAL_STATUSES.find(status => status.value === raw)
  if (exact) { return exact.value }

  const rawRoot = root(raw)
  const match = MARITAL_STATUSES.find(status => rawRoot.startsWith(root(status.value)))

  return match ? match.value : raw
}
